import type {GradientPalette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.OCEANIC_20,
    scheme: [
        '#AEF8FE',
        '#9FF2FE',
        '#90EAFE',
        '#81E1FE',
        '#71D6FE',
        '#62CAFE',
        '#53BCFE',
        '#44ADFE',
        '#359DFD',
        '#258AFD',
        '#1677FD',
        '#0762FD',
        '#024FF3',
        '#023EE4',
        '#0230D5',
        '#0222C5',
        '#0117B6',
        '#010DA7',
        '#010498',
        '#050189',
    ],
    gradient: true,
} as GradientPalette;
